"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateLinks = exports.validateLevels = exports.validateNodes = void 0;
const lodash_1 = __importDefault(require("lodash"));
const arrayValidate = function (array, key) {
  let parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Sankey options object';
  // check for no key
  if (!array) {
    return [`${parent} contains no key '${key}'`];
  }
  // check for non-array key
  if (!Array.isArray(array)) {
    return [`${parent} key '${key}' is not an array`];
  }
  // check for empty key
  if (array.length === 0) {
    return [`${parent} key '${key}' is empty`];
  }
  return [];
};
const validateIds = function (array, parent) {
  let idAccessor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _ref => {
    let {
      id
    } = _ref;
    return id;
  };
  const errors = [];
  // check for entries with no ID
  array.forEach((item, i) => {
    if (!item || !idAccessor(item)) {
      errors.push(`'${parent}[${i}]' has no id`);
    }
  });
  // check for duplicate IDs
  const duplicates = (0, lodash_1.default)(array).filter(idAccessor).groupBy(idAccessor).pickBy(group => group.length > 1).keys().value();
  if (duplicates.length > 0) {
    errors.push(`Duplicate node IDs found in '${parent}': ${duplicates.join(', ')}`);
  }
  return errors;
};
const checkSetsMatch = function (firstArr, firstName, secondArr, secondName) {
  let setType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'Node';
  const errors = [];
  const extraInFirst = lodash_1.default.difference(firstArr, secondArr);
  if (extraInFirst.length > 0) {
    errors.push(`${setType} IDs found in '${firstName}' but not in '${secondName}': ${extraInFirst.join(', ')}`);
  }
  const extraInSecond = lodash_1.default.difference(secondArr, firstArr);
  if (extraInSecond.length > 0) {
    errors.push(`${setType} IDs found in '${secondName}' but not in '${firstName}': ${extraInSecond.join(', ')}`);
  }
  return errors;
};
const validateNodes = nodes => {
  // check that nodes is an array with entries
  const basicCheck = arrayValidate(nodes, 'nodes');
  if (basicCheck.length > 0) return basicCheck;
  // check individual node IDs
  return validateIds(nodes, 'nodes');
};
exports.validateNodes = validateNodes;
const validateLevels = (levels, nodes) => {
  // check that levels is an array with entries
  const basicCheck = arrayValidate(levels, 'levels');
  if (basicCheck.length > 0) return basicCheck;
  // check individual level IDs
  let errors = validateIds(levels, 'levels');
  if (errors.length > 0) return errors;
  let allLevelNodes = [];
  // check that each set of nodes for each level is valid on its own
  levels.forEach((level, i) => {
    // check that each level has a 'nodes' array with entries
    const basicLevelCheck = arrayValidate(level.nodes, 'nodes', `levels[${i}]`);
    if (basicLevelCheck.length > 0) errors = errors.concat(basicLevelCheck);
    if (Array.isArray(level.nodes)) {
      allLevelNodes = allLevelNodes.concat(level.nodes);
    }
  });
  // check for duplicate nodes in/between levels
  errors = errors.concat(validateIds(allLevelNodes, 'levels', id => id));
  const nodeIds = nodes.map(_ref2 => {
    let {
      id
    } = _ref2;
    return id;
  });
  // check for IDs in levels that don't first show up in nodes.
  // and for IDs in nodes that aren't used in levels
  errors = errors.concat(checkSetsMatch(allLevelNodes, 'levels', nodeIds, 'nodes'));
  return errors;
};
exports.validateLevels = validateLevels;
const validateLinks = (links, nodes, levels) => {
  // check that links is an array with entries
  const basicCheck = arrayValidate(links, 'links');
  if (basicCheck.length > 0) return basicCheck;
  let errors = [];
  // check that sources and targets exist in nodes
  links.forEach((_ref3, i) => {
    let {
      source,
      target
    } = _ref3;
    // valid sources exist in nodes or are empty (ie. it's a top level node)
    if (source && !nodes.find(_ref4 => {
      let {
        id
      } = _ref4;
      return id === source;
    })) {
      errors.push(`'links[${i}]' source ID not found in 'nodes': ${source}`);
    }
    // valid targets exist in nodes
    if (!target) {
      errors.push(`'links[${i}]' has no target`);
    } else if (!nodes.find(_ref5 => {
      let {
        id
      } = _ref5;
      return id === target;
    })) {
      errors.push(`'links[${i}]' target ID not found in 'nodes': ${target}`);
    }
  });
  if (errors.length > 0) return errors;
  // check for links that are out of order w.r.t. levels
  links.forEach((_ref6, i) => {
    let {
      source,
      target,
      metrics
    } = _ref6;
    let sourceLevel = -1;
    // we already know that both the source and target exist somewhere in nodes
    // because otherwise we would have returned errors above
    if (source) {
      sourceLevel = levels.findIndex(_ref7 => {
        let {
          nodes: levelNodes
        } = _ref7;
        return levelNodes.includes(source);
      });
    }
    const targetLevel = levels.findIndex(_ref8 => {
      let {
        nodes: levelNodes
      } = _ref8;
      return levelNodes.includes(target);
    });
    if (sourceLevel === targetLevel) {
      errors.push(`'links[${i}]' source and target IDs are from same sankey level: ${source}/${target}`);
    }
    if (sourceLevel > targetLevel) {
      errors.push(`'links[${i}]' source ID is from a higher sankey level than target ID: ${source} > ${target}`);
    }
    const basicMetricsCheck = arrayValidate(metrics, 'metrics', `links[${i}]`);
    if (basicMetricsCheck.length > 0) {
      errors = errors.concat(basicMetricsCheck);
    }
  });
  return errors;
};
exports.validateLinks = validateLinks;